module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_photowedding_03@3x-4889d24c44b771863fa98ec18e526a11.webp";